import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { JobRoutes } from './job/job-routes';
import { ScheduleRoutes } from './schedule/schedule-routes';

const ReportOverview = lazy(() => import('./report-overview'));
const ReportCreate = lazy(() => import('./report-create/report-create.component'));
const ReportDetail = lazy(() => import('./report-detail/report-detail.component'));
const ReportUpdate = lazy(() => import('./report-update/report-update.component'));

const JobRoute = JobRoutes();
const ScheduleRoute = ScheduleRoutes();

export function ReportRoutes() {
    return (
        <Route path='reports'>
            <Route
                index
                element={<ReportOverview />}
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <ReportCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':reportId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ReportDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <ReportUpdate />
                        </AsyncComponent>
                    }
                />
                {JobRoute}
                {ScheduleRoute}
            </Route>
        </Route>
    );
}
